<script setup>
import { trans } from '@elements/translation';
import Dropdown from '@molecules/components/Dropdown.vue';

const emit = defineEmits([ 'row-click' ]);

defineProps({
  data: {
    type: Array,
    required: true,
  },
  prefix: {
    type: String,
    required: true,
  },
  rowType: {
    type: String,
    default: 'link',
  },
  tableWithBorder: {
    type: Boolean,
    default: false,
  },
});

const getAdditionalClass = (key, row) => {
  if (key !== 'status') {
    return '';
  }

  return `status-label status-label--${row.status}`;
};
</script>

<template>
  <div :class="{ 'simple-table-mobile-border': tableWithBorder }">
    <template v-if="rowType === 'link'">
      <div v-for="row in data" :key="row.id" class="simple-table-mobile__row">
        <div class="simple-table-mobile__column simple-table-mobile__column--name">
          {{ row.name }}
        </div>
        <div class="simple-table-mobile__column--infos">
          <span
            class="simple-table-mobile__column--status"
            :class="getAdditionalClass('status', row)"
          >
            {{ trans(`gestion.${row.object}.status.${row.status}`) }}
          </span>
          <span class="simple-table-mobile__column--price">
            {{ row.price }}
          </span>
        </div>
        <div class="simple-table-mobile__column simple-table-mobile__column--period">
          {{ row.period }}
        </div>
      </div>
    </template>
    <template v-if="rowType === 'action'">
      <div
        v-for="(row, index) in data"
        :key="index"
        class="simple-table-mobile-actions__row"
        @click="emit('row-click', row)"
      >
        <div class="simple-table-mobile-actions__column simple-table-mobile-actions__column--infos">
          <p class="column-actions--amount">
            {{ row.amount }}
          </p>
          <p class="column-actions--name">
            {{ row.name }}
          </p>
        </div>

        <div
          class="simple-table-mobile-actions__column simple-table-mobile-actions__column--contract"
          :class="{ 'simple-table-mobile-actions__column--label': row.label }"
        >
          <p v-if="row.period" class="column-actions--period">
            {{ row.period }}
          </p>
          <span v-if="row.label" :class="`status-label status-label--${row.label.status}`">
            {{ row.label.value }}
          </span>
          <p v-if="row.commission_type" :class="`commission commission--${row.commission_type}`">
            {{ trans(`gestion.commission_type.${row.commission_type}`) }}
          </p>
        </div>

        <div class="simple-table-mobile-actions__column simple-table-mobile-actions__column--actions">
          <Dropdown :options="row.actions" />
        </div>
      </div>
    </template>
  </div>
</template>
